import React from 'react'
import { Link } from 'react-router-dom'
import { useCanAccess } from 'src/hooks/useIsBlocked'
import styled from 'styled-components'

export default function ReceiptPriceGuidance({ venueId }) {
  const canSuppliers = useCanAccess('suppliers')
  return (
    <Guidance>
      <summary>Price wrong? Choose the right workflow</summary>
      <p>
        <strong>Current catalogue price is wrong:</strong> request a
        supplier/product refresh through{' '}
        {canSuppliers && venueId ? (
          <Link to={`/v/${venueId}/suppliers`}>Your Suppliers</Link>
        ) : (
          'Your Suppliers (ask an authorised colleague)'
        )}
        .
      </p>
      <p>
        <strong>Receipt entry is wrong:</strong> correct the actual delivered
        quantity or price through Report Error. For a completed receipt, use
        Edit receipt if your role permits it.
      </p>
      <p>
        <strong>Receipt is correct, supplier charge is wrong:</strong> keep the
        receipt unchanged. Open the supplier invoice and choose Review
        difference to request credit.
      </p>
    </Guidance>
  )
}
const Guidance = styled.details`
  margin: 12px 0;
  padding: 12px;
  background: #fafafa;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  overflow-wrap: anywhere;
  summary {
    cursor: pointer;
    font-weight: 600;
  }
  p {
    margin: 10px 0 0;
  }
`
